import React, { useState, useMemo } from 'react';
import { Search } from '@shared/ui/search/search';
import { Filter } from '@shared/ui/filter/filter';
import { OrganizationsListDataRequest } from '@entities/organization/api/organization-types';
import { useOrganizationsInfinityListQuery } from '@entities/organization/api/organization-api';
import { Select } from '@shared/ui/select/select';
import { useOrganizationSelect } from '@features/catalog/mutate-catalog/lib/hooks/use-organization-options/use-organization-options';
import { FilterListOrderProps } from './types';
import { FilterContent, SearchWrapper } from './filter-list-orders.styles';
import { DEFAULT_ORDERS_LIST_ADMIN_PARAMETERS } from '@pages/orders-admin-page/ui/constants';
import { ADMIN_ORDER_STATUS_OPTIONS } from '@entities/order/config/ui-constants';
import { OrderStatus } from '@shared/model/order';
import { SORT_ORDERS_CLEAR_PARAMETERS } from './constants';

export const FilterListOrder: React.FC<FilterListOrderProps> = ({ children, parameters, setParameters }) => {
    /* Organizations */
    const [organizationsListParameters, setOrganizationsListParameters] = useState<OrganizationsListDataRequest>({
        take: 10,
    });
    const {
        data: organizationsList,
        isLoading: isOrganizationsLoading,
        isFetching: isOrganizationsFetching,
    } = useOrganizationsInfinityListQuery(organizationsListParameters);
    const {
        organizationOptions,
        organizationEmptyOption,
        isShowEmptyLoaderOrganizations,
        infinityScrollOrganizationsProps,
        onSearchOrganizations,
    } = useOrganizationSelect({
        organizationsData: organizationsList,
        isLoading: isOrganizationsLoading,
        isFetching: isOrganizationsFetching,
        setOrganizationsListParameters,
    });

    const selectedCompanyIds = useMemo(() => {
        return organizationOptions.filter((organization) =>
            parameters.companyIds?.includes(Number(organization.value))
        );
    }, [parameters.companyIds, setParameters]);

    return (
        <SearchWrapper>
            <Search
                sortParametersAfterClearSearch={SORT_ORDERS_CLEAR_PARAMETERS}
                placeholder='Поиск по названию продукта'
                parameters={parameters}
                setParameters={setParameters}
            />
            {children}
            <Filter onResetAllFilters={() => setParameters(DEFAULT_ORDERS_LIST_ADMIN_PARAMETERS)}>
                <FilterContent>
                    <Select
                        multiselect
                        isAsync
                        clearable
                        label='Организации'
                        placeholder='Выберите организации из списка'
                        isShowPreloaderInList={isShowEmptyLoaderOrganizations}
                        onSearch={onSearchOrganizations}
                        infinityScrollProps={infinityScrollOrganizationsProps}
                        options={organizationOptions}
                        values={selectedCompanyIds || organizationEmptyOption}
                        onChange={(values) =>
                            setParameters((prev) => ({
                                ...prev,
                                companyIds: values.map((company) => Number(company.value)),
                            }))
                        }
                    />
                    <Select
                        label='Статус'
                        multiselect
                        placeholder='Выберите из списка'
                        values={ADMIN_ORDER_STATUS_OPTIONS.filter((option) =>
                            parameters.statuses?.includes(option.value as OrderStatus)
                        )}
                        options={ADMIN_ORDER_STATUS_OPTIONS}
                        onChange={(value) =>
                            setParameters((prev) => ({
                                ...prev,
                                statuses: value.map((status) => status.value) as OrderStatus[],
                            }))
                        }
                    />
                </FilterContent>
            </Filter>
        </SearchWrapper>
    );
};
